module.exports = __webpack_public_path__ + "assets/img/37_1537.66d3f67a.jpg";